export const ONETRUSTLICENSE: string = `${(window as any).ONETRUSTLICENSE}`;
